import React, { useState, useEffect } from "react";
import { BsPersonPlusFill } from "react-icons/bs";
import { Row, Form, Col, Button, Alert } from "react-bootstrap";
import axios from '../../Authservices/axiosInstance';
import { useParams, useNavigate } from "react-router-dom";

export default function EditManualLeave() {
  const [leaveCount, setLeaveCount] = useState(0);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");

  const { userId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/leavesmanual/leave-records/${userId}`);
        if (response.data.leaveRecords && response.data.leaveRecords.length > 0) {
          const userRecord = response.data.leaveRecords[0];
          setLeaveCount(userRecord.leaveCount);
          setUserName(userRecord.name);
        } else {
          setError("User data not found.");
        }
      } catch (error) {
        console.error("Error fetching leave count:", error);
        setError("Failed to fetch leave count. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchUserData();
    }
  }, [userId]);

  const incrementLeave = () => setLeaveCount((prev) => prev + 1);
  const decrementLeave = () => setLeaveCount((prev) => Math.max(0, prev - 1));

  const handleLeaveCountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^[0-9\b]+$/.test(value)) {
      setLeaveCount(value ? parseInt(value, 10) : 0);
    }
  };

  const updateLeaveCount = async () => {
    try {
      const response = await axios.put("https://backend.ems.uk.hiradentallab.com/api/leavesmanual/modify", {
        userId,
        leaveCount,
      });

      if (response.status === 200) {
        setAlertMessage("Leave count updated successfully!");
        setAlertVariant("success");
        setShowAlert(true);

        // Wait 2 seconds, then redirect
        setTimeout(() => {
          navigate("/leave-records");
        }, 2000);
      }
    } catch (error) {
      console.error("Error updating leave count:", error);
      setAlertMessage("Failed to update leave count. Please try again later.");
      setAlertVariant("danger");
      setShowAlert(true);
    }
  };

  return (
    <div className="container-fluid">
      <div>
        <h1 className="add-attendance-title">
          <BsPersonPlusFill /> {loading ? "Loading..." : `View Leave Count for ${userName}`}
        </h1>
        <hr />
      </div>

      <div className="add-attendance-container">
        {/* Alert Message */}
        {showAlert && (
          <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
            {alertMessage}
          </Alert>
        )}

        {/* Error Message */}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {/* Leave Counter */}
        {!loading && userId && (
          <Row className="align-items-end mb-3">
            <Form.Group as={Col} xs={12} md="auto">
              <Form.Label>Leave Count:</Form.Label>
              <div className="d-flex align-items-center">
                <Button variant="secondary" onClick={decrementLeave}>-</Button>
                <Form.Control
                  type="text"
                  value={leaveCount}
                  onChange={handleLeaveCountChange}
                  className="mx-2 text-center"
                  style={{ width: "60px" }}
                />
                <Button variant="secondary" onClick={incrementLeave}>+</Button>
              </div>
            </Form.Group>
          </Row>
        )}

        {/* Update Button */}
        <Button variant="primary" onClick={updateLeaveCount}>
          Update Leave Count
        </Button>
      </div>
    </div>
  );
}

